import { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button, VARIANTS } from '@Green-Dot-Corporation/eureka-ui-buttons';

// Styles
import './styles/callout-actions.scss';

class CalloutActions extends PureComponent {
    static defaultProps = {
        actions: [],
        onActionClick: () => Promise.resolve(),
    };

    static propTypes = {
        contextCls: PropTypes.string,
        actions: PropTypes.array,
        onActionClick: PropTypes.func,
    };

    render() {
        const { contextCls, children } = this.props;
        const primaryAction = this.getAction(true);
        const secondaryAction = this.getAction();

        return (
            <div className={cx(this.baseCls, contextCls)}>
                <div className={`${this.baseCls}__inner`}>
                    {children}
                    {!children && (
                        <Fragment>
                            {secondaryAction &&
                                this.renderAction(secondaryAction)}
                            {primaryAction && this.renderAction(primaryAction)}
                        </Fragment>
                    )}
                </div>
            </div>
        );
    }

    renderAction = (action) => {
        const { onActionClick } = this.props;

        return <Button {...action} onClick={onActionClick} />;
    };

    getAction = (isPrimary = false) => {
        const { actions } = this.props;
        const VARIANT = isPrimary ? 'PRIMARY' : 'SECONDARY';

        return actions.find((action) => {
            return (
                action?.variant === VARIANTS[VARIANT] ||
                action?.variant === VARIANTS[`${VARIANT}_DESTRUCTIVE`]
            );
        });
    };

    baseCls = 'eureka-callout-actions';
}

export default CalloutActions;
